import FlashcardMetadata from '@/classes/flashcardMetadata';

const state = () => ({
  flashcardMetadata: {},
  fetchingPromisesById: {},
});

const getters = {
  flashcardMetadata: state => state.flashcardMetadata,
  flashcardMetadataByFlashcardId: state => flashcardId => state.flashcardMetadata[flashcardId] || null,
  fetchingPromiseById: state => flashcardId => state.fetchingPromisesById[flashcardId] || null,
};

const mutations = {
  setFlashcardMetadata: function(state, metadata) {
    state.flashcardMetadata = {
      ...state.flashcardMetadata,
      [metadata.flashcard.id]: metadata,
    };
  },
  setPromise: function(state, { flashcardId, promise }) {
    state.fetchingPromisesById = {
      ...state.fetchingPromisesById,
      [flashcardId]: promise,
    };
  },
  clearPromise: function(state, flashcardId) {
    state.fetchingPromisesById = {
      ...state.fetchingPromisesById,
      [flashcardId]: null,
    };
  },
};

const actions = {
  fetch({ dispatch, commit, getters, rootGetters }, flashcard) {
    const params = { id: flashcard.id };
    // If the metadata is already in the store, return it
    if (getters.flashcardMetadataByFlashcardId(flashcard.id)) {
      return Promise.resolve(getters.flashcardMetadataByFlashcardId(flashcard.id));
    }
    // If the metadata is being fetched, return the promise
    if (getters.fetchingPromiseById(flashcard.id)) {
      return getters.fetchingPromiseById(flashcard.id);
    }
    const promise = rootGetters['session/ajax'].get('/app_flashcard_meta_data', { params })
      .then(({ data }) => {
        if (data?.appFlashcardMetaData) {
          const metadata = new FlashcardMetadata(data.appFlashcardMetaData, flashcard);
          commit('clearPromise', flashcard.id);
          commit('setFlashcardMetadata', metadata);
          return metadata;
        }
      })
      .catch(error => {
        console.error('Error fetching flashcard metadata', error);
        commit('clearPromise', flashcard.id);
        return Promise.reject(error);
      });

    commit('setPromise', { flashcardId: flashcard.id, promise });

    return promise;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
